import { render } from "./RankingTableSummary012.vue?vue&type=template&id=8177fa28&scoped=true"
import script from "./RankingTableSummary012.vue?vue&type=script&lang=js"
export * from "./RankingTableSummary012.vue?vue&type=script&lang=js"

import "./RankingTableSummary012.vue?vue&type=style&index=0&id=8177fa28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8177fa28"]])

export default __exports__